import { observable, action } from 'mobx';
import { Entity } from '..';

// TODO move to school project
export default class SchoolSettings extends Entity {
    constructor(settings?: Partial<SchoolSettings>) {
        super(settings);
        if (settings) this.update(settings);
    }

    // TODO @predefined
    @observable isRegistrationAgreementEnabled: boolean;
    @observable registrationAgreementText: string | null
    @observable isCookieNotificationEnabled: boolean;
    @observable cookieNotificationText: string | null
    @observable footerHtml: string | null;
    @observable isPageFooterEnabled: boolean;
    @observable isLearnPageFooterEnabled: boolean;
    @observable userSessionCountLimit: number;
    @observable userSessionCountLimitEnabled: boolean;
    @observable deductionEnabled: boolean = false;
    @observable deduction: number;

    @action update(settings: Partial<SchoolSettings>, allowUndefined = false) {
        super.update(settings, allowUndefined);
    }

    copy() {
        return new SchoolSettings({
            id: this.id,
            isRegistrationAgreementEnabled: this.isRegistrationAgreementEnabled,
            registrationAgreementText: this.registrationAgreementText,
            isCookieNotificationEnabled: this.isCookieNotificationEnabled,
            cookieNotificationText: this.cookieNotificationText,
            footerHtml: this.footerHtml,
            isPageFooterEnabled: this.isPageFooterEnabled,
            isLearnPageFooterEnabled: this.isLearnPageFooterEnabled,
            userSessionCountLimit: this.userSessionCountLimit,
            userSessionCountLimitEnabled: this.userSessionCountLimitEnabled,
            deductionEnabled: this.deductionEnabled,
            deduction: this.deduction
        });
    }

    static fromJson(json: any) {
        return new SchoolSettings({
            ...json,
            footerHtml: json.footerText,
        });
    }
}